import _ from 'lodash';
import { setTrackingId } from './helpers';
import { SESSION_FETCH_SUCCESS } from '../../redux/modules/actions';

export const reduxHandlers = {};

reduxHandlers[SESSION_FETCH_SUCCESS] = function handleSessionFetch(action) {
	const xaraTrackingId = _.get(action, 'result.user.trackingId');
	setTrackingId(xaraTrackingId);
};


// WEBPACK FOOTER //
// ./src/lib/Segment/reduxTrackers.js